import { createFileRoute } from '@tanstack/react-router'
import { requiredRoles } from '@/shared/utils/require-roles'
import InvoiceEditPage from '@/pages/invoice/invoice-edit-page'
import { setEntityTag } from '@/lib/sentry/entity-tags'

export const Route = createFileRoute(
  '/_invoice-flow/org/$orgId/invoices/$invoiceId'
)({
  // SUPER_ADMIN only — every action on this screen is an Invoice create/update/
  // delete, which the API grants to no other role; anyone else gets the 403
  // page, not a form whose every save fails (#2421).
  beforeLoad: () => {
    requiredRoles([])
  },
  // Tag Sentry so any error on this detail view filters to the invoice.
  loader: ({ params: { invoiceId } }) => {
    setEntityTag('invoice', invoiceId)
  },
  component: InvoiceEditPage,
})
